import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.weak-map.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _keys = /*#__PURE__*/new WeakMap();
var _sparsifiedValue = /*#__PURE__*/new WeakMap();
var _map = /*#__PURE__*/new WeakMap();
/* eslint-disable no-underscore-dangle */
// This implements a sparse version of the Map
var SparseMap = /*#__PURE__*/function (_Map) {
  _inherits(SparseMap, _Map);
  var _super = _createSuper(SparseMap);
  function SparseMap(sparseRow, definedKeys, keyAsString) {
    var _this;
    var sparsifiedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, SparseMap);
    _this = _super.call(this);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _keys, void 0);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _sparsifiedValue, void 0);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _map, void 0);
    _classPrivateFieldSet(_sparsifiedValue, _assertThisInitialized(_this), sparsifiedValue);
    _classPrivateFieldSet(_keys, _assertThisInitialized(_this), keyAsString ? new Set(definedKeys.map(function (key) {
      return key.toString();
    })) : new Set(definedKeys));

    // sparseRow can come in format for a Map constructor, in that case just store inside the map
    if (Array.isArray(sparseRow)) {
      _classPrivateFieldSet(_map, _assertThisInitialized(_this), new Map(sparseRow));
      _classPrivateFieldSet(_keys, _assertThisInitialized(_this), _classPrivateFieldGet(_map, _assertThisInitialized(_this)).keys());
      return _possibleConstructorReturn(_this);
    }

    // Assume sparseRow's format is a compressed column matrix of one column
    _classPrivateFieldSet(_map, _assertThisInitialized(_this), new Map());
    sparseRow._index.forEach(function (key, i) {
      var definedKey = definedKeys[key];
      var value = sparseRow._values[i];
      var keyToSet = keyAsString ? definedKey.toString() : definedKey;
      _classPrivateFieldGet(_map, _assertThisInitialized(_this)).set(keyToSet, value);
    });
    return _this;
  }
  _createClass(SparseMap, [{
    key: "size",
    get: function get() {
      return _classPrivateFieldGet(_keys, this).size;
    }
  }, {
    key: "has",
    value: function has(key) {
      return _classPrivateFieldGet(_keys, this).has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var _classPrivateFieldGet2;
      return (_classPrivateFieldGet2 = _classPrivateFieldGet(_map, this).get(key)) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : _classPrivateFieldGet(_sparsifiedValue, this);
    }
  }, {
    key: "applyModifier",
    value: function applyModifier(modifier) {
      var _this2 = this;
      _classPrivateFieldGet(_map, this).forEach(function (value, key) {
        _classPrivateFieldGet(_map, _this2).set(key, modifier(value));
      });
      _classPrivateFieldSet(_sparsifiedValue, this, modifier(_classPrivateFieldGet(_sparsifiedValue, this)));
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this3 = this;
      _classPrivateFieldGet(_keys, this).forEach(function (key) {
        callbackfn(_this3.get(key), key, _this3);
      });
    }
  }, {
    key: "keys",
    value: function keys() {
      return _classPrivateFieldGet(_keys, this);
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      var _this4 = this;
      var iterator = _classPrivateFieldGet(_keys, this).values();
      return {
        next: function next() {
          var _iterator$next = iterator.next(),
            value = _iterator$next.value,
            done = _iterator$next.done;
          if (done) {
            return {
              value: undefined,
              done: true
            };
          }
          return {
            value: [value, _this4.get(value)],
            done: false
          };
        }
      };
    }
  }]);
  return SparseMap;
}(/*#__PURE__*/_wrapNativeSuper(Map));
export default SparseMap;